import { HttpResponse, HttpRequestConfig } from '@/utils/http-utils';
import siteConfigService from '@/services/site.config.service';
import httpService from '@/services/http.service';
import { Attributes, PageAttributes, PageAttributeType, PageAttributeTypeArray } from '@/entities/page.attributes';
import storageServices from '@/services/storage.service';
import JSONUtils from '@/utils/json-utils';
import ObjectUtils from '@/utils/object-utils';
import { CacheConfig } from '@/entities/cache';
import logoutHandler from '@/events/handlers/logout.handler';


class PageAttributesService {
  private pageAttributeApiEndpointLeyName: string = 'generic.pageAttributes';

  public async getPageAttributes(): Promise<PageAttributes> {
    try {
      const pageAttributesApi: any = await siteConfigService.getApiEndpoint(this.pageAttributeApiEndpointLeyName);
      const plId: number = await storageServices.getPrivateLabelId();


      const cacheName: string = 'pageAttributes';
      const cacheKey: string = `${plId}`;
      const cacheConfig: CacheConfig = {
        name: cacheName,
        key: cacheKey,
        options: {
          cacheKeepOneKeyOnly: true,
          timeToLive: -1,
          forceUpdate: false,
          secondLevel: true,
        },
      };
      const config: HttpRequestConfig = {
        cache: cacheConfig,
      };

      const apiRes: HttpResponse<PageAttributes> = await httpService.get<PageAttributes>(pageAttributesApi, config);
      let pageAttributes: PageAttributes = null;
      if (ObjectUtils.isString(apiRes.data)) {
        pageAttributes = JSONUtils.parse((`${apiRes.data}`));
      } else {
        pageAttributes = apiRes.data || new PageAttributes();
      }
      return pageAttributes;
    } catch (e) {
      await logoutHandler.logout(e);
      return new PageAttributes();
    }
  }
  public async getFlatteredPageAttributes(pageAttributes0: PageAttributes = null): Promise<Map<number, Attributes>> {
    const pageAttributes: PageAttributes = pageAttributes0 || await this.getPageAttributes();
    const key: string = '';
    const attributesMap: Map<number, Attributes> = new Map<number, Attributes>();
    for (let i = 0; i < PageAttributeTypeArray.length; i++) {
      const typeId: number = PageAttributeTypeArray[i];
      const attributes: Attributes = PageAttributesService.getPageAttributeByTypeIdFromPageAttributes(pageAttributes, typeId);
      attributes.attributes = attributes.attributes || {};
      attributesMap.set(typeId, attributes);
    }
    return attributesMap;
  }

  public async getPageAttributeByTypeId(typeId: number): Promise<Attributes> {
    const pageAttributes: PageAttributes = await this.getPageAttributes();
    return PageAttributesService.getPageAttributeByTypeIdFromPageAttributes(pageAttributes, typeId);
  }

  public async getSelectedTemplateCodeByPageCode(pageCode: string): Promise<string> {
    const attributes: Attributes = await this.getPageAttributeByTypeId(PageAttributeType.WIDGET_PAGE_TEMPLATE);
    let selectedTemplateName: string = '';
    if (attributes && attributes.attributes) {
      selectedTemplateName = attributes.attributes[pageCode] || '';
    }
    return selectedTemplateName;
  }

  private static getPageAttributeByTypeIdFromPageAttributes(pageAttributes: PageAttributes, typeId: number): Attributes {
    const attributesList: Array<Attributes> = pageAttributes.attributes || new Array<Attributes>();
    for (let i = 0; !!attributesList && !!attributesList.length && i < attributesList.length; i++) {
      if (attributesList[i].type.id === typeId) {
        return attributesList[i];
      }
    }
    return new Attributes();
  }
}


// Export a singleton instance in the global namespace
export default new PageAttributesService();
